// extracted by mini-css-extract-plugin
module.exports = {"bg":"index_bg__2qasx"};